const title = document.title

/**
 * This hook is a bit poorly placed but I needed it on the sign in page too
 */
export const APPLICATION_NAME = title
